import React from 'react';
import { Shield, Target, Briefcase, ChevronRight, Calendar, ArrowRight } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { SectionHeader } from '../components/ui/SectionHeader';
export function HomePage() {
  return <div className="min-h-screen flex flex-col" data-id="element-93">
      <Navbar data-id="element-94" />

      <main className="flex-grow pt-[7.25rem] md:pt-[7.25rem]" data-id="element-95">
        {/* ── HERO ── */}
        <section className="relative min-h-[85vh] flex items-center tactical-grid border-b border-brand-gray-800" data-id="element-96">
          <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/80 to-brand-black z-0" data-id="element-97" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full py-20" data-id="element-98">
            <div className="max-w-3xl" data-id="element-99">
              <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-8 clip-edges" data-id="element-100">
                <span className="w-2 h-2 bg-brand-teal animate-pulse" data-id="element-101" />
                Be The Standard
              </div>

              <h1 className="text-5xl md:text-7xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-102">
                Medina Tactical <br data-id="element-103" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-104">
                  Dynamics
                </span>
              </h1>

              <p className="text-xl text-brand-gray-300 mb-10 max-w-2xl font-light border-l-2 border-brand-teal pl-6 leading-relaxed" data-id="element-105">
                Equipping professionals with{' '}
                <strong className="text-brand-white font-semibold" data-id="element-106">
                  360° situational awareness
                </strong>{' '}
                and elite tactical training.
              </p>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-107">
                <Button href="/training" variant="primary" size="lg" className="group" data-id="element-108">
                  Training Events
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-109" />
                </Button>
                <Button href="#Mission" variant="outline" size="lg" data-id="element-110">
                  Our Mission
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* ── PROOF PLACEHOLDER ── */}
        <section className="py-12 border-b border-brand-gray-800 bg-brand-gray-900/50" data-id="element-111">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-112">
            <p className="text-xs font-bold text-brand-gray-500 uppercase tracking-widest mb-6" data-id="element-113">
              Trusted By
            </p>
            <div className="flex justify-center items-center py-8 border border-dashed border-brand-gray-700 bg-brand-gray-900/50" data-id="element-114">
              <span className="text-brand-gray-500 font-mono text-sm" data-id="element-115">
                [Placeholder: Client logos provided later]
              </span>
            </div>
          </div>
        </section>

        {/* ── CORE CAPABILITIES ── */}
        <section className="py-16 md:py-24 lg:py-32 relative" data-id="element-116">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
            <SectionHeader title="Core Capabilities" data-id="element-118" />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-119">
              <Card hoverable className="flex flex-col h-full" data-id="element-120">
                <Shield className="w-12 h-12 text-brand-teal mb-6" data-id="element-121" />
                <h3 className="text-xl font-bold text-brand-white mb-4 uppercase tracking-wide" data-id="element-122">
                  Law Enforcement
                </h3>
                <p className="text-base text-brand-gray-400 mb-8 flex-grow" data-id="element-123">
                  Specialized Training and Consulting for Law Enforcement
                  professionals.
                </p>
                <a href="/law-enforcement-capabilities" className="inline-flex items-center text-brand-teal font-bold uppercase tracking-wider text-sm hover:text-brand-teal-light transition-colors group" data-id="element-124">
                  Learn More{' '}
                  <ChevronRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-125" />
                </a>
              </Card>

              <Card hoverable className="flex flex-col h-full border-brand-teal/30 bg-brand-teal/5" data-id="element-126">
                <Target className="w-12 h-12 text-brand-teal mb-6" data-id="element-127" />
                <h3 className="text-xl font-bold text-brand-white mb-4 uppercase tracking-wide" data-id="element-128">
                  Crisis Situations
                </h3>
                <p className="text-base text-brand-gray-400 mb-8 flex-grow" data-id="element-129">
                  Preparation and Strategic Planning for Crisis Situations.
                </p>
                <a href="/crisis-management-planning" className="inline-flex items-center text-brand-teal font-bold uppercase tracking-wider text-sm hover:text-brand-teal-light transition-colors group" data-id="element-130">
                  Learn More{' '}
                  <ChevronRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-131" />
                </a>
              </Card>

              <Card hoverable className="flex flex-col h-full" data-id="element-132">
                <Briefcase className="w-12 h-12 text-brand-teal mb-6" data-id="element-133" />
                <h3 className="text-xl font-bold text-brand-white mb-4 uppercase tracking-wide" data-id="element-134">
                  Corporate
                </h3>
                <p className="text-base text-brand-gray-400 mb-8 flex-grow" data-id="element-135">
                  Corporate Planning and Strategies for critical incidents.
                </p>
                <a href="/corporate-critical-incidents-planning" className="inline-flex items-center text-brand-teal font-bold uppercase tracking-wider text-sm hover:text-brand-teal-light transition-colors group" data-id="element-136">
                  Learn More{' '}
                  <ChevronRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-137" />
                </a>
              </Card>
            </div>
          </div>
        </section>

        {/* ── MISSION ── */}
        <section id="Mission" className="py-16 md:py-24 lg:py-32 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-138">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-140">
              <div data-id="element-141">
                <SectionHeader title="Our Mission" data-id="element-142" />

                <p className="text-xl text-brand-white font-medium mb-6 leading-relaxed" data-id="element-143">
                  Medina Tactical Dynamics is committed to providing our clients
                  with highest quality of service combined with a strong sense
                  of 360° situational awareness.
                </p>

                <div className="space-y-4 text-brand-gray-400 mb-8" data-id="element-144">
                  <p className="text-base" data-id="element-145">
                    Providing quality services to our clients is our top
                    priority. We are available to assist you with your training
                    and consulting needs, delivering current and long-term
                    solutions through innovative ideas, strategies, and
                    preparedness.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6" data-id="element-146">
                    {['Educational Programs', 'Course Development', 'Use of Force Litigation', 'Law Enforcement Consulting', 'Corporate & Civilian Entities', 'Private Investigation'].map(item => <li key={item} className="flex items-center gap-2 text-sm" data-id="element-147">
                        <div className="w-1.5 h-1.5 bg-brand-teal flex-shrink-0" data-id="element-148" />
                        {item}
                      </li>)}
                  </ul>
                </div>

                <div className="p-6 border border-brand-gray-700 bg-brand-black clip-edges" data-id="element-149">
                  <h3 className="text-lg font-semibold text-brand-white uppercase mb-2" data-id="element-150">
                    The Medina Standard
                  </h3>
                  <p className="text-sm text-brand-gray-400 mb-6" data-id="element-151">
                    We operate with a 24/7 mentality in customer support,
                    ensuring you are always prepared for the unexpected.
                  </p>
                  <Button href="/Contact-Medina Tactical" variant="outline" size="sm" data-id="element-152">
                    Contact Us
                  </Button>
                </div>
              </div>

              <div className="relative h-full min-h-[400px] border border-brand-gray-700 bg-brand-black p-2" data-id="element-153">
                <div className="absolute inset-2 border border-brand-gray-800 flex items-center justify-center bg-brand-gray-900/50 tactical-grid" data-id="element-154">
                  <span className="text-brand-gray-500 font-mono text-sm" data-id="element-155">
                    [Placeholder: Tactical Training Image]
                  </span>
                </div>
                <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal" data-id="element-156" />
                <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal" data-id="element-157" />
                <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal" data-id="element-158" />
                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal" data-id="element-159" />
              </div>
            </div>
          </div>
        </section>

        {/* ── UPCOMING EVENTS ── */}
        <section className="py-16 md:py-24 lg:py-32 relative tactical-grid" data-id="element-160">
          <div className="absolute inset-0 bg-brand-black/90 z-0" data-id="element-161" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-162">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-16 gap-6" data-id="element-163">
              <SectionHeader title="Upcoming Training Events" className="mb-0" data-id="element-164" />
              <Button href="/training" variant="primary" data-id="element-165">
                <Calendar className="w-4 h-4" data-id="element-166" />
                View Calendar
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-167">
              {[{
              title: 'Front Line Patrol Leadership and Training',
              link: '/law-enforcement-capabilities'
            }, {
              title: 'Instructor Development and Education',
              link: '/training'
            }, {
              title: 'Advanced Tactical Training',
              link: '/about-apc'
            }].map((event, i) => <div key={i} className="group border border-brand-gray-800 bg-brand-black p-6 hover:border-brand-teal transition-colors flex flex-col" data-id="element-168">
                  <div className="text-xs font-bold text-brand-teal uppercase tracking-widest mb-4 flex items-center gap-2" data-id="element-169">
                    <span className="w-2 h-2 bg-brand-teal rounded-sm" data-id="element-170" />
                    Featured Course
                  </div>
                  <h3 className="text-xl font-bold text-brand-white mb-6 uppercase leading-snug flex-grow" data-id="element-171">
                    {event.title}
                  </h3>
                  <a href={event.link} className="inline-flex items-center text-brand-gray-400 font-bold uppercase tracking-wider text-sm group-hover:text-brand-teal transition-colors" data-id="element-172">
                    Learn More{' '}
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-173" />
                  </a>
                </div>)}
            </div>
          </div>
        </section>

        {/* ── NEWSLETTER + CONTACT SPLIT ── */}
        <section className="border-t border-brand-gray-800" data-id="element-174">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-175">
            {/* Newsletter */}
            <div className="bg-brand-teal/10 p-12 lg:p-24 flex flex-col justify-center border-b lg:border-b-0 lg:border-r border-brand-gray-800" data-id="element-176">
              <div className="max-w-md mx-auto w-full" data-id="element-177">
                <h2 className="text-3xl font-bold uppercase tracking-wider mb-4 text-brand-white" data-id="element-178">
                  Stay Prepared
                </h2>
                <p className="text-base text-brand-gray-300 mb-8" data-id="element-179">
                  Subscribe to stay up to date on the latest tactical course and
                  education offerings.
                </p>
                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-180">
                  <Input label="Email Address" type="email" placeholder="Enter your email" required data-id="element-181" />
                  <div className="p-4 border border-brand-gray-700 bg-brand-black/50 text-xs text-brand-gray-500 flex items-center justify-center" data-id="element-182">
                    [reCAPTCHA Placeholder]
                  </div>
                  <Button type="submit" variant="primary" className="w-full" data-id="element-183">
                    Subscribe
                  </Button>
                </form>
              </div>
            </div>

            {/* Contact */}
            <div className="bg-brand-gray-900 p-12 lg:p-24 flex flex-col justify-center" data-id="element-184">
              <div className="max-w-md mx-auto w-full" data-id="element-185">
                <h2 className="text-3xl font-bold uppercase tracking-wider mb-4 text-brand-white" data-id="element-186">
                  Have Questions?
                </h2>
                <p className="text-base text-brand-gray-400 mb-8" data-id="element-187">
                  Reach out to our team for consulting or training inquiries.
                </p>
                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-188">
                  <Input label="Your Name" type="text" placeholder="John Doe" required data-id="element-189" />
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-190">
                    <Input label="Email" type="email" placeholder="john@example.com" required data-id="element-191" />
                    <Input label="Phone" type="tel" placeholder="(555) 123-4567" data-id="element-192" />
                  </div>
                  <Input label="What are your needs?" multiline placeholder="Describe your training or consulting needs..." required data-id="element-193" />
                  <div className="p-4 border border-brand-gray-700 bg-brand-black/50 text-xs text-brand-gray-500 flex items-center justify-center" data-id="element-194">
                    [reCAPTCHA Placeholder]
                  </div>
                  <Button type="submit" variant="outline" className="w-full text-brand-white border-brand-gray-600 hover:border-brand-teal" data-id="element-195">
                    Contact Us
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-196" />
    </div>;
}